<template>
  <div>
    <b-modal v-model="showWarning" :title="$t('session.timeoutWarningTitle')">
      {{ $t('session.timeoutWarning' ) }}
      <div slot="modal-footer" class="modal-footer">
        <button class="btn btn-default" @click="logout">
          {{ $t('signOut') }}
        </button>
        <button class="btn btn-primary">
          {{ $t('session.stayConnected') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { BModal } from "bootstrap-vue";
  import { throttle } from "lodash-es";

  export default {
    name: "SessionTimeout",
    components: {
      BModal,
    },
    data() {
      return {
        timer: null,
        showWarning: false
      }
    },
    computed: mapGetters(['isLoggedIn']),
    watch: {
      isLoggedIn: function(status) {
        if (status) {
          this.startTimer();
        } else {
          clearTimeout(this.timer);
        }
      }
    },
    created() {
      document.addEventListener('keyup', throttle(this.startTimer, 1000));
      document.addEventListener('mouseup', throttle(this.startTimer, 1000));
      document.addEventListener('mousemove', throttle(this.startTimer, 1000));
      document.addEventListener('touchend', throttle(this.startTimer, 1000));
      document.addEventListener('touchmove', throttle(this.startTimer, 1000));
      if (this.$store.getters.isLoggedIn) {
        this.startTimer();
      }
    },
    methods: {
      startTimer() {
        if (!this.isLoggedIn) {
          return;
        }
        // reset timer and hide warning if visible
        clearTimeout(this.timer);
        this.showWarning = false;
        // warn them in 29 minutes
        this.timer = setTimeout(() => {
          this.warnTimeout();
        }, 1000 * 60 * 29);
      },
      warnTimeout() {
        this.showWarning = true;
        // log them out 1 minute after warning if no activity
        this.timer = setTimeout(() => {
          this.showWarning = false;
          this.$router.push({name: 'logout', params: {timeout: true}}).catch(e => {});
        }, 1000 * 60);
      },
      logout() {
        // manual logout via warning modal
        clearTimeout(this.timer);
        this.$router.push({name: 'logout'}).catch(e => {});
      }
    }
  }
</script>

<style scoped>

</style>